import React, { useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';

const INACTIVE_TIMEOUT = 30 * 60 * 1000; // 30 minutes

export function AuthWrapper({ children }) {
  const { user, logout } = useAuth();

  useEffect(() => {
    if (!user) return;

    let inactivityTimer;

    const resetTimer = () => {
      if (inactivityTimer) clearTimeout(inactivityTimer);
      inactivityTimer = setTimeout(() => {
        logout();
      }, INACTIVE_TIMEOUT);
    };

    // Events to monitor user activity
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
    
    events.forEach(event => {
      document.addEventListener(event, resetTimer);
    });

    // Initial timer
    resetTimer();

    // Cleanup
    return () => {
      if (inactivityTimer) clearTimeout(inactivityTimer);
      events.forEach(event => {
        document.removeEventListener(event, resetTimer);
      });
    };
  }, [user, logout]);

  return children;
} 